import { Rating as GammaRating } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

type RatingProps = React.ComponentProps<typeof GammaRating>

type Props = Omit<RatingProps, 'missingLabel'> & {
  missingLabel?: string
}

const Rating = (props: Props) => (
  <GammaRating {...props} missingLabel={i18n.t('common.missing_field')} />
)

export default Rating
